import React from 'react';
import { node, number } from 'prop-types';
import { Divider } from 'antd';

import I18nCustomFormatter from 'Src/common/components/i18nCustomFormatter';
import './style.scss';

function FormWrapper({ step, header, totalSteps, children }) {
  return (
    <div className="onboarding-form-wrapper p24">
      <div className="onboarding-form-title">
        <p className="arc-H150 arc-color-gray-7 mb0">
          <I18nCustomFormatter id="step-label" values={{ step, totalSteps }} />
        </p>
        {header}
      </div>
      <Divider />
      <div className="onboarding-form-container">{children}</div>
    </div>
  );
}

FormWrapper.propTypes = {
  children: node.isRequired,
  header: node.isRequired,
  step: number.isRequired,
  totalSteps: number.isRequired,
};

export default FormWrapper;
